import { createTheme } from '@mui/material/styles';

export default createTheme({
  breakpoints: {
    values: {
      lg: 1024,
      md: 768,
      sm: 640,
      xl: 1280,
      xs: 0,
    },
  },
  components: {
    MuiAppBar: {
      defaultProps: {
        position: 'fixed',
      },
      styleOverrides: {
        root: {
          '@media (min-width: 1024px)': {
            top: '1rem',
          },
          backgroundColor: 'transparent',
          backgroundImage: 'none',
          boxShadow: 'none',
          overflow: 'hidden',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          '@media (min-width: 768px)': {
            minWidth: '240px',
          },
          borderRadius: '1.5rem',
          fontSize: '1rem',
          minWidth: '100%',
          textTransform: 'none',
        },
      },
    },
    MuiContainer: {
      defaultProps: {
        disableGutters: true,
        maxWidth: 'xl',
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          '&:not(.menu-button)': {
            '&:hover': { color: 'var(--gold1)' },

            '&:not(.transparent)': {
              '&:hover': { backgroundColor: 'var(--white)' },
              backgroundColor: 'var(--white)',
            },
            color: 'var(--black)',

            padding: '0',
          },
        },
      },
    },
    MuiToolbar: {
      defaultProps: {
        disableGutters: true,
      },
      styleOverrides: {
        root: {
          '@media (min-width: 640px)': {
            minHeight: 0,
          },
          justifyContent: 'space-between',
        },
      },
    },
  },
  direction: 'ltr',
  palette: {
    background: {
      default: 'var(--dark2)',
      paper: 'var(--dark2)',
    },
    mode: 'dark',
    primary: {
      contrastText: '#fff',
      main: '#edc667',
    },
    secondary: {
      contrastText: '#fff',
      main: '#b9792e',
    },
    text: {
      primary: 'var(--white)',
      secondary: 'var(--gray1)',
    },
  },
  typography: {
    body1: {
      fontFamily: '"Exo 2", sans-serif',
      fontSize: '1rem',
      fontWeight: 300,
      lineHeight: 1.5,
    },
    body2: {
      fontFamily: '"Exo 2", sans-serif',
      fontSize: '0.875rem',
      fontWeight: 300,
      lineHeight: 1.5,
    },
    fontFamily: '"Exo 2", sans-serif',
    fontSize: 18,
    fontWeightBold: 700,
    fontWeightLight: 300,
    fontWeightMedium: 500,
    fontWeightRegular: 400,
    h1: {
      '@media (min-width: 1024px)': {
        fontSize: '2.25rem',
      },
      fontFamily: '"Oswald", sans-serif',
      fontSize: '1.5rem',
      fontWeight: 400,
      lineHeight: 1.25,
      position: 'absolute',
      right: '5vw',
      span: {
        color: 'var(--gold1)',
        fontFamily: 'inherit',
        fontSize: 'inherit',
      },
      textAlign: 'left',
      textShadow:
        '0 0 4px var(--page-image-header-shadow), 0 0 4px var(--page-image-header-shadow), 0 0 4px var(--page-image-header-shadow)',
      top: '25%',
    },
    h2: {
      '@media (min-width: 1024px)': {
        fontSize: '1.5rem',
      },
      fontFamily: '"Oswald", sans-serif',
      fontSize: '1.25rem',
      fontWeight: 400,
      lineHeight: 1.25,
      textAlign: 'left',
    },
    h3: {
      '@media (min-width: 1024px)': {
        fontSize: '1.25rem',
      },
      fontFamily: '"Oswald", sans-serif',
      fontSize: '1.125rem',
      fontWeight: 400,
      lineHeight: 1.25,
      textAlign: 'left',
    },
    h4: {
      '@media (min-width: 1024px)': {
        fontSize: '1.125rem',
      },
      fontFamily: '"Exo 2", sans-serif',
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: 1.25,
      textAlign: 'left',
    },
    htmlFontSize: 18,
  },
});
